/**
 * @description api请求基础路径
 */
const baseUrl = {
  dev: '/api',
  test: 'http://qa-gateway.andunip.cn',
  pro: 'https://gateway.andunip.com'
}
/**
 * @description 获取腾讯存储文件接口前缀
 */
const getTencentFilePath = {
  dev: '/getDevTencentFile',
  test: '/getDevTencentFile',
  pro: '/getProTencentFile'
}
/**
 * @description 安牌api请求基础路径
 */
const anpaiUrl = 'https://api.anpaitm.com'
/**
/**
* @description 腾讯上传公有桶名
*/
const uploadPublicUrl =
  process.env.type == 'test' || process.env.NODE_ENV == 'development'
    ? 'dev-public-1251740668'
    : 'pro-public-1251740668'
/**
 * @description 腾讯上传私有桶名
 */
const uploadPrivateUrl =
  process.env.type == 'test' || process.env.NODE_ENV == 'development'
    ? 'dev-private-1251740668'
    : 'pro-public-1251740668'
/**
 * @description 域名
 */
const basePath = {
  dev: 'http://wechatapi.utools.club',
  test: 'http://test.lawyer.andunip.cn',
  pro: 'http://lawyer.andunip.com'
}
/**
 * @description 接口地址 重定向链接地址
 */
export default {
  baseUrl: mapUrl(baseUrl),
  getTencentFilePath: mapUrl(getTencentFilePath),
  basePath: mapUrl(basePath),
  anpaiUrl: anpaiUrl,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    Accept: 'application/json'
  },
  pageSizeOpts: [15, 30, 50, 100],
  pageSize: 15,
  modalPageSizeOpts: [5, 10, 15, 20],
  modalPageSize: 5,
  uploadPublicUrl: uploadPublicUrl,
  uploadPrivateUrl: uploadPrivateUrl
}

function mapUrl(url) {
  if (process.env.NODE_ENV == 'development') {
    return url['dev']
  } else if (process.env.type == 'test') {
    return url['test']
  } else {
    return url['pro']
  }
}



// WEBPACK FOOTER //
// ./src/libs/config.js